<template>
  <section class="hero">
    <div class="container">
      <div class="title-wrapper">
        <h1 class="title">Discover the best remote jobs</h1>
        <p class="subtitle">
          Build a top career and access leading remote positions at global
          companies, within +/- 4 hours of your timezone
        </p>
        <ApplyButton
          cta-section="hero"
          class="proxify-btn proxify-btn-white"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: { ApplyButton },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
